import React from 'react';

interface HighlightBoxProps {
  children: React.ReactNode;
}

export default function HighlightBox({ children }: HighlightBoxProps) {
  return (
    <div className="highlight bg-[#e6f0ff] p-6 rounded-md mb-8 border-l-4 border-primary text-lg">
      {children}
    </div>
  );
} 